import { useTranslator } from "@eo-locale/react";

import { Progress, Text, Stack } from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";

const ProgressBar = (): JSX.Element => {
  const { translate } = useTranslator();
  const { pages } = useAppSelector((state) => state.survey);

  if (pages.length <= 1) return null;

  const currentPage = pages.find((p) => p.current);
  const completed = pages.filter(
    (page) => page.sequence < currentPage.sequence
  ).length;
  const remaining = pages.filter(
    (p) => p.sequence >= currentPage.sequence
  ).length;

  const progress = (completed * 100) / (completed + remaining);
  return (
    <Stack gap={1} data-testid="survey-participant-progress">
      <Text
        fontSize="0.75rem"
        lineHeight="133%"
        fontWeight="normal"
        letterSpacing="0.2px"
        color="gray.600"
        textAlign="center"
        data-testid="survey-participant-progress-label"
      >
        {[`${Math.round(progress)}%`, translate("survey.answered")].join(" ")}
      </Text>
      <Progress
        css={{
          "& [data-part=track]": { borderRadius: "4px", h: "3" },
          "& [data-part=range]": { borderRadius: 0 }
        }}
        value={progress}
        aria-label={translate("survey.survey")}
        data-testid="survey-participant-progress-bar"
      />
    </Stack>
  );
};

export default ProgressBar;
